var _defs, _title;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgC(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "300 400 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1299.903,
    height: 1023.307
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.199597, 0, 0, 1.194952, -892.655212, 18.976774)",
    style: {
      clipPath: "url(#clip-2)"
    }
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "C")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_112",
    "data-name": "Ellipse 112",
    className: "cls-7",
    cx: 1075.488,
    cy: 400.693,
    r: 70.317,
    style: {
      fill: "rgb(255, 229, 95)",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_402",
    "data-name": "Line 402",
    className: "cls-8",
    x2: 1115.272,
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px"
    },
    x1: 1035.336,
    y1: 405.849,
    y2: 405.849
  }), /*#__PURE__*/React.createElement("text", {
    id: "C",
    className: "cls-13",
    style: {
      whiteSpace: "pre",
      fill: "rgb(53, 82, 121)",
      fontFamily: "Assistant-Bold, Assistant",
      fontSize: "54.585px",
      fontWeight: 700,
      letterSpacing: "0.54585px",
      lineHeight: "87.336px",
      perspectiveOrigin: "24.7656px 34px"
    },
    x: 0,
    y: 338.631
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1090,
    y: 394.631,
    style: {
      fontSize: "54.6px",
      wordSpacing: 0,
      letterSpacing: "0.55px"
    }
  }, "C")), /*#__PURE__*/React.createElement("text", {
    id: "_53-71",
    "data-name": "53-71",
    className: "cls-14",
    style: {
      whiteSpace: "pre",
      fill: "rgb(53, 82, 121)",
      fontFamily: "Assistant-Bold, Assistant",
      fontSize: 30,
      fontWeight: 700,
      lineHeight: 48,
      perspectiveOrigin: "38.8125px 18.5px"
    },
    x: 0,
    y: 404.822
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1110,
    y: 435.822,
    style: {
      fontSize: 30,
      wordSpacing: 0
    }
  }, "53-71"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/C.1ee2f73ccdaf01090966d5a336495a75.svg";
export { ForwardRef as ReactComponent };